import { PropsWithChildren, useMemo } from "react";
import "./style.css";

type Props = {
  id?: string;
  gap?: number | string;
  justify?: string;
  align?: string;
  className?: string;
  style?: { [key: string]: any };
  events?: { [key: string]: any };
} & PropsWithChildren;

function VStack(props: Props) {
  const defaultStyles = useMemo(() => {
    const style = {} as React.CSSProperties;

    if (props.gap) {
      style.gap = props.gap;
    }

    if (props.justify) {
      style.justifyContent = props.justify;
    }

    if (props.align) {
      style.alignItems = props.align;
    }

    return style;
  }, [props.align, props.gap, props.justify]);

  return (
    <div
      id={props.id}
      className={`fl-col ${props.className || ""}`}
      style={{ ...defaultStyles, ...(props.style ?? {}) }}
      {...(props.events ?? {})}
    >
      {props.children}
    </div>
  );
}

function HStack(props: Props) {
  const defaultStyles = useMemo(() => {
    const style = {} as React.CSSProperties;

    if (props.gap) {
      style.gap = props.gap;
    }

    if (props.justify) {
      style.justifyContent = props.justify;
    }

    if (props.align) {
      style.alignItems = props.align;
    }

    return style;
  }, [props.align, props.gap, props.justify]);

  return (
    <div
      id={props.id}
      className={`fl-row ${props.className || ""}`}
      style={{ ...defaultStyles, ...(props.style ?? {}) }}
      {...(props.events ?? {})}
    >
      {props.children}
    </div>
  );
}

export { VStack, HStack };
